import pkg from '../../package.json.js';

const SDK_NAME = pkg.name;
const SDK_VERSION = pkg.version;

export { SDK_NAME, SDK_VERSION };
